export default __webpack_public_path__ + "static/media/phone_active.088a4a07.png";